<script>
export default {
  name: 'FundraiserLayout1'
}
</script>

<template>
  <div>
    <h1>Fundraiser Layout 1</h1>
    NOt used
  </div>
</template>

<style scoped>

</style>
